import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { cn } from '@/utils/cn';

/**
 * Quiet column-sort control shared by Patienter, Opgaver, Henvisninger and Filer.
 *
 * The active column keeps a single small arrow in body ink, so the direction
 * stays readable. The other columns keep a faint double arrow. Neither uses
 * the teal accent.
 */
export function ColumnSortHeader({
  label,
  active,
  direction,
  onClick,
  ariaLabel,
}: {
  label: string;
  active: boolean;
  direction: 'asc' | 'desc';
  onClick: () => void;
  ariaLabel: string;
}) {
  const SortIcon = active ? (direction === 'asc' ? ArrowUp : ArrowDown) : ArrowUpDown;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className="group inline-flex max-w-full items-center gap-s1 rounded-sm text-left hover:text-ds-text focus-visible:shadow-ring focus-visible:outline-none"
    >
      {label}
      <SortIcon
        strokeWidth={2}
        className={cn(
          'h-3 w-3 shrink-0',
          active ? 'text-ds-text' : 'text-ds-muted opacity-40 group-hover:opacity-70',
        )}
        data-sort-state={active ? 'active' : 'idle'}
        data-sort-direction={active ? direction : undefined}
        data-sort-active={active ? 'true' : undefined}
        aria-hidden
      />
    </button>
  );
}
